module.exports = __webpack_public_path__ + "static/media/satellite.d18c91ec.svg";